<template>
  <div>
    <component :is="currentComponent" v-bind="currentProps"></component>
  </div>
</template>

<script>
import TrainingVideo from '../../components/client/trainingModule/TrainingVideo'
import TrainingQuiz from '../../components/client/trainingModule/TrainingQuiz'

export default {
  name: 'TrainingModule',
  props: {
    training: {
      type: Object
    }
  },
  components: {
    'training-video': TrainingVideo,
    'training-quiz': TrainingQuiz
  },
  created () {
    this.$bus.on('swapComponent', this.swapComponent)
  },
  beforeDestroy () {
    this.$bus.off('swapComponent', this.swapComponent)
  },
  mounted () {
    if (!this.training) {
      this.$router.push({ name: 'TrainingCatalog' })
    }
  },
  data () {
    return {
      currentComponent: 'training-video',
      compProps: {}
    }
  },
  computed: {
    currentProps () {
      let props = { training: this.training }
      Object.keys(this.compProps).forEach(key => {
        props[key] = this.compProps[key]
      })
      return props
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    swapComponent (component) {
      this.currentComponent = component.component
      this.scrollToTop()
      if (component.props) {
        this.compProps = component.props
      } else {
        this.compProps = {}
      }
    }
  }
}
</script>
